<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     新建模型
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="dev-creater-wrapper">
    <el-dialog
      custom-class="dev-creater"
      v-loading="posting"
      :visible.sync="dialogShow"
      width="900px"
      :close-on-click-modal="false"
      append-to-body
      :modal-append-to-body="false"
    >
      <el-row type="flex">
        <el-col :span="4">
          <el-menu ref="menu" class="dev-creater-menu" :default-active="currentCreateMethod" @select="handleSelectChange">
            <el-menu-item index="1">
              <i class="el-icon-plus"></i>
              <span slot="title">新建模型</span>
            </el-menu-item>

            <el-menu-item index="2">
              <i class="el-icon-headset"></i>
              <span slot="title">定制模型</span>
            </el-menu-item>

            <el-menu-item index="3" v-if="dev_square_enable" class="flex align-items-center">
              <div class="square">
                <i class="iconfont icon-model-square"></i>
              </div>
              <span slot="title">模型广场</span>
            </el-menu-item>
          </el-menu>
        </el-col>
        <el-col :span="20" v-loading="uploading" class="flex-center" style="min-height: 360px; padding: 0px 100px">
          <el-form
            v-if="currentCreateMethod == '1'"
            ref="devCreaterForm"
            :model="dev"
            :rules="rules"
            label-position="left"
            label-width="120px"
            style="width: 420px;"
          >
            <el-form-item label="名称" prop="dev_name">
              <el-input v-model="dev.dev_name" clearable />
            </el-form-item>
            <el-form-item prop="protocal">
              <span slot="label">
                <el-popover placement="top" width="200" trigger="hover" content="模型创建后协议不可变更">
                  <span slot="reference">
                    协议
                    <i class="el-icon-info text-light"></i>
                  </span>
                </el-popover>
              </span>

              <el-radio-group v-model="dev.protocal" size="small">
                <el-radio-button label="MBRTU">Modbus RTU</el-radio-button>
                <el-radio-button label="MQTT">MQTT 3.1.1</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="备注">
              <el-input type="textarea" :rows="2" v-model="dev.remark" />
            </el-form-item>
            <div class="advanced-settings" @click="toggleAdvanced">
              <span>高级设置</span>
              <i :class="['el-icon-arrow-down', {'is-active': showAdvanced}]"></i>
            </div>
            <el-collapse-transition>
              <div v-show="showAdvanced">
                <el-form-item label="图标">
                  <el-upload
                    class="avatar-uploader flex"
                    :class="{ disabled: fileList.length > 0 }"
                    ref="upload"
                    accept=".png, .jpg, .jpeg, .gif"
                    action
                    list-type="picture-card"
                    :limit="1"
                    :http-request="handleUpload"
                    :multiple="false"
                    :on-change="handleChange"
                    :file-list="fileList"
                    :before-upload="beforeUpload"
                    :on-error="handleUploadFail"
                    :on-success="handleUploadSuccess"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                  >
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <!-- 使用el-image进行预览 -->
                  <el-image v-show="false" ref="previewImage" :src="imageUrl" :preview-src-list="[imageUrl]"></el-image>
                </el-form-item>
                <el-form-item label="标识">
                  <el-input v-model="dev.dev_key" clearable />
                </el-form-item>
                <el-form-item label="品牌">
                  <el-select v-model="dev.brandid" filterable clearable style="width: 100%;">
                    <el-option v-for="item in brandArr" :key="item.brandid" :label="item.brand_title" :value="item.brandid"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="品类">
                  <el-select v-model="dev.category" multiple allow-create filterable style="width: 100%;">
                    <el-option v-for="item in categoryArr" :key="item.cateid" :label="item.cate_title" :value="item.cate_title"></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-collapse-transition>
            <div class="flex-center" style="margin-top: 60px">
              <el-button class="extend" @click="dialogShow = false">取消</el-button>
              <el-button class="extend" type="primary" :loading="posting" @click="submit">提交</el-button>
            </div>
          </el-form>

          <div v-if="currentCreateMethod == '2'" class="flex-center column">
            <div class="mb">如果您需要定制模型服务，请联系我们</div>
            <img src="@/assets/wechat-qrcode.jpg" width="200" />
          </div>
        </el-col>
      </el-row>
    </el-dialog>

    <dev-plaza v-if="plazaShow" :show.sync="plazaShow" @clone="fetchData(1)" />
  </div>
</template>

<script>
import {
  devPostApi,
  brandGetAllApi,
  categoryGetAllApi,
} from "@/api/dev/devApi";
import { preUpload, finishUpload } from "@/api/ei/eiMallApi";
import { decrypt } from "@/utils/common";
import OSS from "ali-oss";
import { v4 as uuidv4 } from 'uuid';

export default {
  name: "DevCreater",

  components: {
    DevPlaza: () => import("./DevPlaza.vue"),
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      currentCreateMethod: "1",
      showAdvanced: false,

      dev: {
        dev_name: "",
        protocal: "MBRTU",
        remark: "",
        avatar: "",
        brandid: "",
        dev_key: "",
        category: [],
      },
      rules: {
        dev_name: [{ required: true, message: "不能为空", trigger: "blur" }],
        protocal: [{ required: true, message: "不能为空", trigger: "change" }],
      },
      posting: false,

      csvTempleteUrl:
        "https://api.frippler.com/attachment/docus/global/mbrtu_standard_csv_template.csv",
      uploading: false,

      imageUrl: "",
      fileList: [],
      file_size: 0,

      plazaShow: false,
      url: "",

      brandArr: [],
      categoryArr: [],
    };
  },

  computed: {
    dialogShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },

    dev_square_enable() {
      return this.$store.state.godStore.dev_square_enable
    },
  },

  watch: {
    plazaShow(val) {
      if (!val) {
        this.currentCreateMethod = "1";
        // 激活菜单1
        this.$refs.menu.$el.children[0].click();
      }
    },
  },

  created() {
    this.fetchBrand();
    this.fetchCategory();
  },

  methods: {
    fetchBrand() {
      brandGetAllApi().then((res) => {
        if (!res.errno) {
          this.brandArr = res.data.list;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    fetchCategory() {
      categoryGetAllApi().then((res) => {
        if (!res.errno) {
          this.categoryArr = res.data.list;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    handleSelectChange(idx) {
      if (idx == 3) {
        this.plazaShow = true;
      }
      this.currentCreateMethod = idx;
    },

    submit() {
      this.$refs["devCreaterForm"].validate((valid) => {
        if (valid) {
          this.posting = true;
          this.dev.avatar = this.url;
          const param = {
            dev_name: this.dev.dev_name, //模型名称
            protocal: this.dev.protocal, //协议类型: MBRTU | MQTT
            remark: this.dev.remark, //备注信息
            avatar: this.dev.avatar, //头像
            dev_key: this.dev.dev_key, //模型唯一标识
            brandid: this.dev.brandid, //品牌ID
            category: this.dev.category //品类数组
          };
          devPostApi(param).then((res) => {
            this.posting = false;
            if (!res.errno) {
              this.$message.success("模型新建成功！");
              this.$emit("onSubmit");
              this.dialogShow = false;
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },

    handleChange(file, fileList) {
      this.file_size = file.size;
      if (fileList.length > 1) {
        this.fileList = fileList.slice(-1);
      } else {
        this.fileList = fileList;
      }
    },

    beforeUpload(file) {
      const formatArr = ["image/jpeg", "image/png", "image/jpg", "image/gif"];
      if (formatArr.indexOf(file.type) === -1) {
        this.$message.error("上传图标格式只支持 jpeg、 jpg、 png、 gif！");
        return false;
      }
      if (file.size > 2 * 1024 * 1024) {
        this.$message.error("上传图标大小不能超过 2M！");
        return false;
      }
      this.uploading = true;
      return true;
    },

    handleUploadFail(err, file, fileList) {
      this.uploading = false;
      this.$message.error("文件上传失败");
    },

    handleUploadSuccess(response, file, fileList) {
      this.uploading = false;
      this.$message.success("上传成功");
      this.fileList = fileList;
    },

    handleUpload(option) {
      this.uploading = true;
      const that = this;
      if (option.file) {
        // const suffix = option.file.name.substring(
        //   option.file.name.lastIndexOf(".")
        // );
        // let pointIdx = option.file.name.lastIndexOf(".");
        // let filename = "";
        // if (pointIdx > 0) filename = option.file.name.substring(0, pointIdx);
        preUpload().then((res) => {
          if (!res.errno) {
            const authdata = JSON.parse(decrypt(res.data));

            const ossClient = new OSS({
              accessKeyId: authdata.access_key_id,
              accessKeySecret: authdata.access_key_secret,
              bucket: authdata.bucket,
              region: authdata.region,
              stsToken: authdata.security_token,
              cname: authdata.cname,
              secure: authdata.secure,
              endpoint: authdata.endpoint,
            });

            const filename = uuidv4().split('-').join('') + option.file.name.substring(option.file.name.lastIndexOf("."))

            const name = "/dev/avatar/" + filename;
            const headers = option.headers || {};
            const options = {
              // 设置并发上传的分片数量。
              parallel: 4,
              // 设置分片大小。默认值为1 MB，最小值为100 KB。
              partSize: 1024 * 1024,
              headers: {
                ...headers,
              },
              mime: option.file.type,
            };
            const upload_url =
              `http${authdata.secure ? "s" : ""}://` +
              authdata.endpoint + name
            that.url = upload_url;

            ossClient
              .multipartUpload(name, option.file, {
                ...options,
              })
              .then((result) => {
                const finish_params = {
                  url: upload_url,
                  filename: filename,
                };
                finishUpload(finish_params).then((resp) => {
                  this.uploading = false;
                  if (!resp.errno) {
                  } else {
                    that.$message.error(res.message);
                  }
                });
              });
          }
        });
      }
    },

    handlePictureCardPreview(file) {
      this.imageUrl = file.url;
      // 触发el-image的预览
      this.$nextTick(() => {
        this.$refs.previewImage.clickHandler();
      });
    },

    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.url = ''
    },

    toDoc() {
      window.open("https://wiki.frippler.com/#/docs/fs/fcs/46");
    },

    toggleAdvanced() {
      this.showAdvanced = !this.showAdvanced;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-menu-item:hover,
/deep/.el-menu-item:focus {
  background-color: #f5f7fa;
}
/deep/.el-dialog__body {
  padding: 10px 20px 30px;
}
.dev-creater {
  .el-dialog__body {
    padding-top: 0;
  }
  .dev-creater-menu {
    height: 100%;
    .el-menu-item.is-active {
      background-color: rgba(7, 193, 96, 0.05);
    }
    .el-menu-item .square {
      margin-right: 5px;
      width: 24px;
      text-align: center;
      font-size: 20px;
      vertical-align: middle;
    }
  }
  .avatar-uploader {
    /deep/.el-upload-list__item {
      width: 80px;
      height: 80px;
    }
    &.disabled {
      /deep/.el-upload-list__item {
        display: none;
      }
    }
  }
}

// 添加预览相关样式
/deep/ {
  .el-image-viewer__wrapper {
    .el-image-viewer__btn {
      color: #fff;

      i {
        font-size: 30px;
      }
    }

    .el-image-viewer__actions {
      padding: 15px 0;

      .el-image-viewer__actions__inner {
        i {
          font-size: 30px;
          color: #fff;
          cursor: pointer;
          margin: 0 8px;
        }
      }
    }
  }
}

.advanced-settings {
  font-size: 14px;
  color: #999;
  margin-bottom: 22px;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: all 0.3s;
  
  &:hover {
    color: #07c160;
  }
  
  .el-icon-arrow-down {
    margin-left: 5px;
    transition: transform 0.3s;
    
    &.is-active {
      transform: rotate(180deg);
    }
  }
}
</style>

<style lang="scss">
.dev-creater {
  .disabled .el-upload--picture-card {
    display: none !important;
  }

  .el-upload-list--picture-card {
    height: 80px;
    .el-upload-list__item {
      margin: 0;
    }
  }

  .el-upload--picture-card {
    width: 80px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .el-upload-list--picture-card .el-upload-list__item {
    width: 80px !important;
    height: 80px !important;
  }
  .el-upload-list--picture-card .el-upload-list__item-actions {
    font-size: 18px;
  }
  .el-upload-list--picture-card .el-upload-list__item-actions span + span {
    margin-left: 10px;
  }
}
</style>
